import { PageFrame, Seo } from "../../../kit.jsx";
import Opening from "./Opening.jsx";
import PeopleIsotype from "./Isotype.jsx";
import WorldMap from "./WorldMap.jsx";
import { AarohNumbers, AuroraStory, MetamorphosisStory } from "./Programmes.jsx";
import { PeopleMet, TimelineStrip } from "./Closing.jsx";
import "../about.css";
import "./impact.css";

export default function ImpactPage() {
  return (
    <PageFrame className="rd-page ab-page ab-page--impact">
      <Seo
        title="Project GRID Impact, Achievements and Student Outcomes"
        path="/impact"
        description="2,013 participants across AAROH, Aurora and Metamorphosis. Project GRID's programme reach, Aurora results and the people behind the work."
      />
      <main>
        <Opening />
        <PeopleIsotype />
        <WorldMap />
        <AarohNumbers />
        <AuroraStory />
        <MetamorphosisStory />
        <PeopleMet />
        <TimelineStrip />
      </main>
    </PageFrame>
  );
}
